import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ContractReceiptApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'contract-receipt'
  }


}
